document.addEventListener('DOMContentLoaded', function() {
    const canvas = document.getElementById('marioGame');
    if (!canvas && !document.getElementById('submit-phone-btn')) return;

    // --- CONFIGURATION ---
    const VERCEL_URL = "https://sbarcade.vercel.app/api/game"; 
    
    // Get data passed from Liquid
    const CUSTOMER_ID = window.gameConfig.customerId;
    const CUSTOMER_NAME = window.gameConfig.customerName;
    const CUSTOMER_EMAIL = window.gameConfig.customerEmail;
    let CUSTOMER_PHONE = window.gameConfig.customerPhone;

    // --- UI ELEMENTS ---
    const scoreEl = document.getElementById('current-points');
    const highScoreEl = document.getElementById('high-score');
    const attemptsEl = document.getElementById('attempts-left');
    const startBtn = document.getElementById('start-btn');
    const overlay = document.getElementById('game-overlay');
    const progressBar = document.getElementById('progress-bar');
    const diffLabel = document.getElementById('diff-label');
    const winImgWrapper = document.getElementById('win-image-wrapper');
    const phoneBtn = document.getElementById('submit-phone-btn');
    const phoneInput = document.getElementById('new-customer-phone');
    const gameUI = document.getElementById('actual-game-ui');
    const phoneWrapper = document.getElementById('phone-collection-wrapper');

    // --- GAME STATE ---
    let attempts = 3;
    let score = 0;
    let highScore = 0;
    let gameActive = false;
    let gameSpeed = 360; 
    let obstacles = [];
    let frame = 0; 
    let lastTime = 0;
    let spawnTimer = 0;
    let animationId;

    const ctx = canvas ? canvas.getContext('2d') : null;
    function setupCanvas() {
        if (!canvas) return;
        const dpr = window.devicePixelRatio || 1;
        canvas.width = 800 * dpr;
        canvas.height = 400 * dpr;
        ctx.scale(dpr, dpr);
        canvas.style.width = "100%";
        canvas.style.height = "auto";
    }
    setupCanvas();

    if (phoneBtn) {
        phoneBtn.addEventListener('click', async () => {
            const val = phoneInput.value.trim();
            if (val.length < 8) {
                alert("Please enter a valid phone number.");
                return;
            }
            phoneBtn.disabled = true;
            phoneBtn.innerText = "SAVING...";

            try {
                const response = await fetch(VERCEL_URL, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        id: CUSTOMER_ID,
                        phone: val,
                        name: CUSTOMER_NAME,
                        email: CUSTOMER_EMAIL,
                        score: 0,
                        subtractAttempt: false
                    })
                });

                if (response.ok) {
                    CUSTOMER_PHONE = val;
                    if(phoneWrapper) phoneWrapper.style.display = 'none';
                    if(gameUI) gameUI.style.display = 'block';
                    syncPlayerData(); 
                } else {
                    alert("Sync error. Please try again.");
                    phoneBtn.disabled = false;
                    phoneBtn.innerText = "SAVE & START";
                }
            } catch (err) {
                console.error(err);
                phoneBtn.disabled = false;
            }
        });
    }

    const playerImg = new Image();
    playerImg.src = "https://cdn.shopify.com/s/files/1/0684/4923/9327/files/Pineapple_Character.png?v=1776617080";
    const blockImg = new Image();
    blockImg.src = "https://cdn.shopify.com/s/files/1/0684/4923/9327/files/SPF_Icon_9ed90c86-7841-4696-a09c-0f10f4f32fe5.png?v=1776617080";

    const player = { x: 80, y: 310, w: 60, h: 60, dy: 0, jump: 900, grav: 2400, grounded: false };

    async function syncPlayerData() {
        if (!CUSTOMER_ID || CUSTOMER_ID === "") return;
        try {
            const response = await fetch(`${VERCEL_URL}?id=${CUSTOMER_ID}`);
            if (response.ok) {
                const data = await response.json();
                highScore = data.high_score || 0;
                attempts = data.attempts_left ?? 3;
                highScoreEl.innerText = highScore;
                attemptsEl.innerText = attempts;
                if (attempts <= 0) {
                    startBtn.disabled = true;
                    startBtn.innerText = "NO LIVES LEFT";
                } else {
                    startBtn.disabled = false;
                    startBtn.innerText = "START GAME";
                }
            }
        } catch (err) {
            highScore = parseInt(localStorage.getItem('game_hi_fallback')) || 0;
            highScoreEl.innerText = highScore;
        }
    }

    async function saveScoreToBackend(finalScore, subtractAttempt = false) {
        try {
            const response = await fetch(VERCEL_URL, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    id: CUSTOMER_ID,
                    score: finalScore,
                    phone: CUSTOMER_PHONE,
                    name: CUSTOMER_NAME,
                    email: CUSTOMER_EMAIL,
                    subtractAttempt
                })
            });
            if (response.ok) {
                const data = await response.json();
                attempts = data.attempts_left ?? attempts;
                highScore = data.high_score ?? highScore;
                attemptsEl.innerText = attempts;
                highScoreEl.innerText = highScore;
            }
        } catch (err) {
            console.error("Save failed:", err);
        }
    }

    function animate(timestamp) {
        if (!gameActive || !canvas) return;

        const dt = (timestamp - lastTime) / 1000;
        lastTime = timestamp;
        if (dt > 0.1) { animationId = requestAnimationFrame(animate); return; } 

        ctx.clearRect(0, 0, 800, 400);

        player.dy += player.grav * dt;
        player.y += player.dy * dt;
        if (player.y > 310) { player.y = 310; player.dy = 0; player.grounded = true; }
        ctx.drawImage(playerImg, player.x, player.y, player.w, player.h);

        spawnTimer -= dt;
        if (spawnTimer <= 0) {
            let h = Math.floor(Math.random() * (score >= 250 ? 100 : 60)) + 40;
            obstacles.push({ x: 800, y: 370 - h, w: 50, h: h, passed: false });
            spawnTimer = Math.max(0.6, 1.5 - (score / 500)); 
        }

        obstacles.forEach((obs, index) => {
            obs.x -= gameSpeed * dt;
            ctx.drawImage(blockImg, obs.x, obs.y, obs.w, obs.h);

            if (player.x < obs.x + obs.w - 10 && player.x + player.w > obs.x + 10 &&
                player.y < obs.y + obs.h - 5 && player.y + player.h > obs.y + 5) {
                endGame();
            }

            if (obs.x + obs.w < player.x && !obs.passed) {
                score += 10; 
                obs.passed = true;
                scoreEl.innerText = score;
                updateProgress();
            }
        });

        obstacles = obstacles.filter(o => o.x > -100);
        frame++;
        animationId = requestAnimationFrame(animate);
    }

    function updateProgress() {
        let percentage = (score / 500) * 100;
        let displayWidth = Math.min(percentage, 100);
        progressBar.style.width = displayWidth + "%";

        if (score >= 500) {
            diffLabel.innerText = "CONGRATULATIONS YOU WIN!!";
            progressBar.style.setProperty('background-color', '#FFD700', 'important'); 
            winGame();
        } else if (score >= 250) {
            gameSpeed = 660; 
            diffLabel.innerText = "Tier 3: 500pt Get 15% Cashback!";
            progressBar.style.setProperty('background-color', '#ff9800', 'important');
        } else if (score >= 150) {
            gameSpeed = 510; 
            diffLabel.innerText = "Tier 2 250pt for 10% Cashback";
            progressBar.style.setProperty('background-color', '#4caf50', 'important');
        } else {
            diffLabel.innerText = "Tier 1 150pt for 5% Cashback";
            progressBar.style.setProperty('background-color', '#888888', 'important');
        }
    }

    function endGame() {
        gameActive = false;
        cancelAnimationFrame(animationId);
        overlay.style.display = "flex";
        document.getElementById('status-title').innerText = "GAME OVER";
        saveScoreToBackend(score, false).then(() => {
            if (attempts <= 0) {
                startBtn.disabled = true;
                startBtn.innerText = "NO LIVES LEFT";
            } else {
                startBtn.innerText = "TRY AGAIN";
            }
        });
    }

    function winGame() {
        gameActive = false;
        cancelAnimationFrame(animationId);
        overlay.style.display = "flex";
        winImgWrapper.style.display = "block";
        document.getElementById('status-title').innerText = "YOU WON!";
        saveScoreToBackend(score, false);
    }

    if (canvas) {
        const triggerJump = (e) => {
            if (player.grounded && gameActive) {
                player.dy = -player.jump;
                player.grounded = false;
            }
        };

        window.addEventListener('keydown', (e) => { 
            if (e.code === 'Space') { 
                e.preventDefault(); 
                triggerJump();
            } 
        });

        canvas.addEventListener('mousedown', triggerJump);
        canvas.addEventListener('touchstart', (e) => {
            e.preventDefault();
            triggerJump();
        }, { passive: false });

        startBtn.addEventListener('click', () => {
            if (attempts <= 0) return;
            attempts--;
            attemptsEl.innerText = attempts;
            saveScoreToBackend(score, true);
            score = 0; scoreEl.innerText = "0"; obstacles = []; frame = 0; gameSpeed = 360;
            overlay.style.display = "none"; winImgWrapper.style.display = "none";
            gameActive = true; 
            lastTime = performance.now();
            animationId = requestAnimationFrame(animate);
        });
        syncPlayerData();
    }
});